import { qs, remove } from "@fluorescent/dom";
import { section } from "@/neon";
import mobileCarousel from "@/lib/mobile-carousel";

const sel = {
  partial: "[data-partial]",
  slider: "[data-slider]",
};

const classes = {
  hidden: "hidden",
};

section("complementary-products", {
  onLoad() {
    this.sectionId = this.container.dataset.sectionId;
    this.productId = this.container.dataset.productId;
    this.productSource = this.container.dataset.productSource;
    this.limit = this.container.dataset.limit;

    if (this.productSource === "app-recommendations") {
      this.handleRecommendedProducts();
    } else {
      this.initSlider();
    }
  },

  handleRecommendedProducts() {
    const requestUrl = `${theme.routes.productRecommendations}?section_id=${this.sectionId}&limit=${this.limit}&product_id=${this.productId}&intent=complementary`;

    const request = new XMLHttpRequest();
    request.open("GET", requestUrl, true);

    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        let container = document.createElement("div");
        container.innerHTML = request.response;

        const item = qs(".product-item", container);
        if (item) {
          this.container.innerHTML = qs(sel.partial, container).innerHTML;
          remove(this.container, classes.hidden);
        }

        if (Shopify.designMode) {
          remove(this.container, classes.hidden);
        }
        this.initSlider();
      }
    };
    request.send();
  },

  initSlider() {
    const carousel = qs(sel.slider, this.container);
    if (carousel) {
      this.mobileCarousel = mobileCarousel(carousel);
    }
  },

  onUnload() {
    this.mobileCarousel && this.mobileCarousel.destroy();
  },
});
